var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCharge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20.714 28.571",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.432 13.856-12.185 14.278c-0.18466 0.2212-0.44458 0.3702-0.73236 0.4198-0.28778 0.0497-0.58426-0.0033-0.83537-0.1493-0.25111-0.1459-0.44014-0.3752-0.53262-0.6458-0.09247-0.2707-0.08223-0.5649 0.02885-0.8288l4.2088-10.265h-9.167c-0.23132-3e-4 -0.45778-0.0648-0.65291-0.1861s-0.35087-0.2943-0.44902-0.4989c-0.09815-0.2045-0.13465-0.4321-0.10524-0.6561 0.029413-0.224 0.12353-0.4353 0.27134-0.609l12.185-14.278c0.1847-0.22066 0.4445-0.36924 0.7319-0.41872 0.2874-0.049479 0.5835 0.003432 0.8344 0.14911 0.2509 0.14568 0.4398 0.37444 0.5326 0.64468 0.0927 0.27024 0.083 0.564-0.0274 0.82784l-4.21 10.266h9.167c0.2316-1e-4 0.4585 0.0642 0.6541 0.1855 0.1955 0.1212 0.3516 0.2944 0.4499 0.4992 0.0984 0.2048 0.1349 0.4327 0.1053 0.6571-0.0296 0.2243-0.124 0.4357-0.2723 0.6095z",
    fill: "#000",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharge);
export default __webpack_public_path__ + "static/media/charge.8889c50884220f07a6e84e05f0a59b78.svg";
export { ForwardRef as ReactComponent };